export default __webpack_public_path__ + "static/media/icon-lock-blue.efdda363.svg";